<template>
  <div
    id="accessory"
    class="editor-container"
  >
    <div class="accessory-preview">
      <img
        :src="product.detail_image_url"
        alt="Prislusenstvo"
      >
    </div>
    <!-- Sold -->
    <SoldCapacity v-if="soldCapacity" />
    <!-- Editor -->
    <div class="form-fields">
      <h1>{{ product.name }}</h1>

      <GiftVoucherFields v-if="giftVoucherIds.includes(product.id)" />
      <AccessoryFields v-else />

      <AddToCart
        :add-to-cart="$t('Add stand to cart')"
        :entity="$t('Stand')"
      />
    </div>
    <Loader :text="$t('Accessory loading')" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AddToCart from './AddToCart'
import Loader from '../../../packages/views/loader/Loader'
import AccessoryFields from './attributes/AccessoryFields.vue'
import GiftVoucherFields from './attributes/GiftVoucherFields.vue'
import SoldCapacity from './SoldCapacity.vue'
import { giftVoucherIds } from '../../../../config'

export default {
  components: {
    Loader,
    AddToCart,
    AccessoryFields,
    SoldCapacity,
    GiftVoucherFields,
  },
  computed: {
    ...mapGetters({
      product: 'product/getProduct',
      soldCapacity: 'product/getSoldCapacity',
    }),
  },
  setup() {
    return {
      giftVoucherIds,
    }
  },
}
</script>
